/** Sentinel value for "column value not provided" in non-required fields */
export const NOT_PROVIDED = '__NOT_PROVIDED__';

/**
 * Class fields that must be mapped to a source column before the CSV can be
 * validated. Everything else can be left as "(Not provided)". This mirrors the
 * families mapper so studios are not blocked when their export lacks optional
 * columns.
 */
export const REQUIRED_CLASS_HEADERS = [
  'Title',
  'Hide Class Status',
  'Session',
  'Start Date',
  'End Date',
  'Days',
  'Start Time',
  'End Time',
  'Class Size',
  'Tuition Billing Cycle',
] as const;

export const ClassCSVHeaders = [
  'Title',
  'Class Color',
  'Hide Class Status',
  'Location',
  'Room',
  'start age year',
  'start age month',
  'end age year',
  'end age month',
  'Instructor',
  'Description (Under 200 Characters)',
  'Session',
  'Start Date',
  'End Date',
  'Registration Start Date',
  'Days',
  'Start Time',
  'End Time',
  'Duration',
  'Registration Fee',
  'Tuition Fee',
  'Costume Fee',
  'Class Size',
  'Group',
  'Tuition Billing Cycle',
  'Billing Frequency Days',
  'Hourly Plan Name',
  'Billing Day',
] as const;

export type ClassCSVHeader = (typeof ClassCSVHeaders)[number];

export interface ClassColumnMappingTableData {
  header: string;
  sample: string;
  selectedColumn: string;
  columnValue: string | number | undefined;
}
